import Color from "color";

// Contrast guard for tenant-supplied brand colors.
//
// The directive: if white text on the brand color fails WCAG AA
// (4.5:1) at the 50px primary button size, flip the on-button text
// to `#14110E` instead of asking the admin to compromise on the
// brand color they uploaded. Borders and accents are unaffected.
//
// `Color(input)` can throw on linear-gradient strings, on `undefined`,
// or on malformed hex — we treat those as "use white text" since the
// CSS will gracefully fall back to the brand color default.
export const pickOnBrandTextColor = (brandColor) => {
  try {
    const c = Color(brandColor);
    const whiteContrast = c.contrast(Color("#FFFFFF"));
    if (whiteContrast >= 4.5) {
      return "light";
    }
    return "dark";
  } catch (_e) {
    return "light";
  }
};

// Multicolor Google G mark, 18px. The button's text is the accessible
// name, so the SVG is hidden from assistive tech.
export const GoogleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width="18"
    height="18"
    aria-hidden="true"
  >
    <path
      fill="#FBBC04"
      d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
    />
    <path
      fill="#EA4335"
      d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
    />
    <path
      fill="#34A853"
      d="M24,44c5.166,0,9.860-1.977,13.409-5.192l-6.190-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
    />
    <path
      fill="#4285F4"
      d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.190,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
    />
  </svg>
);
